module.exports = __webpack_public_path__ + "img/Tessellate13.f002babd.jpg";